import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { OfferSection } from './components/OfferSection';
import { PriceSection } from './components/PriceSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-gold/30" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <HookSection data-id="element-4" />
        <PainSection data-id="element-5" />
        <RevelationSection data-id="element-6" />
        <OfferSection data-id="element-7" />
        <PriceSection data-id="element-8" />
        <FAQSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>
      <footer className="bg-charcoal text-cream/50 py-8 text-center text-sm" data-id="element-12">
        <p data-id="element-13">
          © {new Date().getFullYear()} Nudos de Esperanza. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}